<msf-summary-wrapper
  title="{{ 'Crop Yield Forecast' | translate }}"
  [items]="MENU_ITEMS | menuChildren:MenuItemType.CropYieldForecast"
  leftSize="4"
  rightSize="8">
  <div
    right
    #right>
    <div class="summary-card mt-4">
      <div class="flex justify-content-between align-items-center mb-4">
        <h2 class="summary-title mb-0">{{ "Last 5 Analysis Requests" | translate }}</h2>
      </div>

      <p-table
        [value]="recentLogs"
        [scrollable]="true"
        scrollHeight="400px"
        [tableStyle]="{ 'min-width': '50rem' }"
        styleClass="p-datatable-gridlines custom-table"
        [loading]="isLoading">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "Started" | translate }}</th>
            <th>{{ "User" | translate }}</th>
            <th>{{ "Region" | translate }}</th>
            <th class="text-center">{{ "Status" | translate }}</th>
            <th class="text-right">{{ "Success / Total" | translate }}</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-item>
          <tr>
            <td>
              {{ item.startedAt || item.createAt | date: "dd.MM.yyyy HH:mm" }}
            </td>
            <td>{{ getUserName(item.createUser) }}</td>
            <td>{{ getRegionName(item.regionId) }}</td>
            <td class="text-center">
              <span
                class="status-badge"
                [ngClass]="getBadgeClass(item.calculationStatus)">
                {{ item.calculationStatus | translate }}
              </span>
            </td>
            <td class="text-right">
              <span [class.text-success]="item.successfullyProcessedCount > 0">
                {{ item.successfullyProcessedCount || 0 }}
              </span>
              /
              {{ item.totalSeasonsFound || 0 }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td
              colspan="5"
              class="text-center p-4">
              {{ "No analysis history found" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</msf-summary-wrapper>
